module.exports = new __parcel__URL__("Charlie_Text-Thin_Italic.803474d7.woff").toString();